import _Symbol from "@babel/runtime-corejs3/core-js/symbol";
import React from "react";

/**
 * Creates a ref object that triggers a re-render when ref changes
 *
 * This is useful to pass a ref via context and have consumers re-render when
 * element becomes available
 */

const $nextRef = _Symbol('next-ref');
const useRefForContext = function () {
  let initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  const [ref, setRef] = React.useState(initial);
  return React.useMemo(() => ({
    [$nextRef]: null,
    get current() {
      return this[$nextRef] || ref;
    },
    set current(nextRef) {
      this[$nextRef] = nextRef;
      setRef(nextRef);
    }
  }), [ref]);
};
export default useRefForContext;